import { dashboardBffApiClient } from '~/lib/apiClient/clients/dashboardBffApiClient';
import { Roles } from '~/lib/auth';
import { Tenant } from '~/utils/tenants';

export const getAccountHasBudget = async (accountId: string, roles: Roles, tenantId?: Tenant) => {
  const apiClient = dashboardBffApiClient({ roles, tenantId, basePath: 'dashboards' });

  const response = await apiClient.get<{ hasBudgetToCreatePrograms: boolean }>(`/has-budget-to-create-programs/${accountId}`);

  return response.data.hasBudgetToCreatePrograms;
};
